// src/modules/app-views/products/pages/Init/actions/actionButton.js

import { PlusOutlined, FormOutlined } from '@ant-design/icons';
import useZustand from 'hooks/useZustand';

const productsInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_product',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,

    // Primary button handler - navigation to AI page
    onClick: ({ navigate, setPage }) => {
      // Show loading page before navigation to prevent flash
      const setLoadingPageStore = useZustand('boot', 'setLoadingPage', false);
      setLoadingPageStore({ visible: true, extendedDelayToHide: 600 });

      setPage({
        navigate,
        pageName: 'ai',
      });
    },

    // Dropdown: manual insert option (skip AI, go directly to form)
    dropdownItems: [
      {
        key: 'manual',
        label: 'insert_manually',
        icon: <FormOutlined />,
        onClick: ({ navigate, setPage }) => {
          const setLoadingPageStore = useZustand('boot', 'setLoadingPage', false);
          setLoadingPageStore({ visible: true, extendedDelayToHide: 600 });

          setPage({
            navigate,
            pageName: 'document',
            params: { _id: 'add' },
          });
        },
      },
    ],
  };
};

export default productsInitActionButton;
